// Modules
import React from 'react';

// Types
import { AdvertisementVariant, IRowSeparator } from '../../types';

// Components
import Advertisement from '../Advertisement/Advertisement';

interface IVariantRowSeparator extends IRowSeparator {
  variant: AdvertisementVariant;
}

const RowSeparator = (props: IVariantRowSeparator) => {
  const { numRows, index, variant } = props;
  const firstAd = 10;
  const modulus = 20;
  const indexPlus = index + 1;

  // If we don't have enough rows yet we want to display an ad below the last
  // row. Rows are indexed from 0 so we need to add one to the index before
  // we compare it to the number of rows.
  if (numRows < modulus && indexPlus === numRows) {
    return (
      <div>
        <div style={{ width: '100%' }} className="advertisement">
          <Advertisement variant={variant} count={1} />
        </div>
      </div>
    );
  }

  if (indexPlus === firstAd) {
    return (
      <div>
        <div style={{ width: '100%' }} className="advertisement">
          <Advertisement variant={variant} count={1} />
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Display an ad every "modulus" rows */}
      {indexPlus % modulus === 0 ? (
        <div>
          <div style={{ width: '100%' }} className="advertisement">
            <Advertisement variant={variant} count={indexPlus / modulus + 1} />
          </div>
        </div>
      ) : null}
    </>
  );
};

export default RowSeparator;
